import { useState, useEffect } from "react"

import { fetchData } from "../utils"

const Footer = () => {
    const [content, setContent] = useState({})
    
    useEffect (() => {
        fetchData('pageContent/kontakt', 'GET', null, (data) => {
            setContent(data)
        })
    }, [])
    return (
        <div className="footer">
            <div>
                <div className="footer-pages">
                    <h2>
                        Strony
                    </h2>
                    <a href="/">
                        O firmie
                    </a>
                    <a href="/galeria">
                        galeria
                    </a>
                    <a href="/kontakt">
                        kontakt
                    </a>
                    <a href="/wspolpraca">
                        Współpraca
                    </a>
                </div>
                <div className="footer-social-media">
                    <h2>
                        Media
                    </h2>
                    <a href="https://www.tiktok.com/@luxsufitynapinane?_r=1&_t=ZN-92UXMeiFbTr">
                        TikTok
                    </a>
                    <a href="https://www.instagram.com/lux_sufity?igsh=MXNmNTl0MXFxeGpuNA%3D%3D&utm_source=qr">
                        Instagram
                    </a>
                    <a href="https://www.facebook.com/share/1ADLm7YU5U/?mibextid=wwXIfr">
                        Facebook
                    </a>
                </div>
                <div className="footer-kontakt">
                    <h2>
                        Kontakt
                    </h2>
                    <a href={`tel:${content.telefon}`}>
                        {content.telefon}
                    </a>
                    <a href={`mailto:${content.email}`}>
                        {content.email}
                    </a>
                </div>
            </div>
            <div className="uppercase">
                {content.prawo}
            </div>
        </div>
    )
}

export default Footer